module.exports = "/images/vendor/dhtmlx-scheduler/codebase/imgs/loading.gif?bb3e07337c49b0d4abb1f1b4e5d3f37d";